import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { Fragment } from "react";

const useStyles = makeStyles((theme) => ({
  simpleBox: {
    marginBottom: "10px",
  },
  title: {
    [theme.breakpoints.down("s")]: {
      fontSize: "16px",
    },
  },
  paragraph: {
    [theme.breakpoints.down("s")]: {
      fontSize: "10px",
    },
  },
}));
export const SimpleSubTitle = ({ itemList }) =>
  itemList.map((i) => (
    <OuterItemsContainer key={i._id}>
      <ItemTitle>{i.title}</ItemTitle>
      {<SimpleItems subItem={i.sub_items} />}
      {i.status && <span>*{i.status}</span>}
    </OuterItemsContainer>
  ));

export default SimpleSubTitle;

const ItemTitle = ({ children }) => {
  const classes = useStyles();
  return (
    <Typography className={classes.title} variant="h3">
      {children}
    </Typography>
  );
};

const OuterItemsContainer = ({ children }) => {
  const classes = useStyles();
  return <Box className={classes.simpleBox}>{children}</Box>;
};

const SimpleItems = ({ subItem }) => {
  const classes = useStyles();
  return (
    <Typography className={classes.paragraph} variant="body1">
      {subItem &&
        subItem.map((item) => (
          <Fragment key={item._id}>{item.title},</Fragment>
        ))}
    </Typography>
  );
};
